/**
 * Component: Product Kit
 * ------------------------------------------------------------------------------
 * A script to load the related product kit items on the product page.
 *
 * @namespace productKit
 */
import axios from 'axios'
import cssClasses from '../helpers/cssClasses'
import overlay from '../mixins/overlay'

import log from 'salvo-lite/log'

class ProductKit {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            popup: '[data-product-kit-popup=""]',
            closePopup: '[data-product-kit-close]',
            togglePopup: '[data-product-kit-toggle]',
            productKitCardaddToCart: '[data-product-kit-add-to-cart]',
            addBundleToCart: '[data-add-bundle-to-cart]',
            ...JSON.parse(elem.getAttribute('data-product-kit') || '{}')
        }

        /**
         * Node selectors.
         */
        this._nodeSelectors = {
            popup: document.querySelector(this._settings.popup),
            closePopup: document.querySelectorAll(this._settings.closePopup),
            togglePopup: document.querySelectorAll(this._settings.togglePopup),
            productKitCardaddToCart: document.querySelectorAll(this._settings.productKitCardaddToCart),
            addBundleToCart: document.querySelectorAll(this._settings.addBundleToCart)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        this._addEventListeners()
    }

    /**
     * Add event listeners
     */
    _addEventListeners () {
        this._nodeSelectors.productKitCardaddToCart.forEach((button) => {
            button.addEventListener('click', (e) => this._addProductToCart(e))
        })

        this._nodeSelectors.togglePopup.forEach((button) => {
            button.addEventListener('click', (e) => this._togglePopup(e))
        })

        this._nodeSelectors.closePopup.forEach((button) => {
            button.addEventListener('click', (e) => this._closePopup(e))
        })

        this._nodeSelectors.addBundleToCart.forEach((button) => {
            button.addEventListener('click', (e) => this._addBundleToCart())
        })
    }

    _addBundleToCart (e) {
        alert('add bundle to cart')
        // Get all form data and add to cart
    }

    /**
     *  Takes an Event and either ads product to cart or, if the product has variants, toggles the popup
     * @param {Event} e
     */
    _addProductToCart (e) {
        let id = 0
        if (e.target.hasAttribute('data-product-variant-id')) {
            this._togglePopup(e, e.target.getAttribute('data-product-variant-id'))
            return
        } else {
            id = e.target.getAttribute('data-product-id')
        }

        axios.post('/cart/add.js', {
            items: [
                {
                    id: id,
                    quantity: 1
                }
            ]
        }).then((response) => {
            window.Frame.EventBus.emit('AjaxCart:itemAdded', response)
            return response
        }).catch((error) => {
            return error
        })
    }

    /**
     * Takes an event and popup ID and toggles the active state on the approprite popup
     * @param {Event} e
     * @param {Integer} popupId
     */
    _togglePopup (e, popupId = null) {
        let popupEl = this._nodeSelectors.popup
        if (popupId !== null) popupEl = document.querySelector(`[data-product-kit-popup="${popupId}"]`)

        if (popupEl.classList.contains(cssClasses.active)) {
            popupEl.classList.remove(cssClasses.active)
            overlay('namespace:ProductKit').close()
        } else {
            popupEl.classList.remove(cssClasses.active)
            popupEl.classList.add(cssClasses.active)
            const flickityComponentId = popupEl.querySelector('.product-gallery__main-thumbnail').getAttribute('data-component-id')
            if (this._theme.getComponentsById(flickityComponentId)) this._theme.getComponentsById(flickityComponentId)._carousel.resize()
            if (this._theme.getComponentsById(`${flickityComponentId}--thumbs`)) this._theme.getComponentsById(`${flickityComponentId}--thumbs`)._carousel.resize()
            overlay('namespace:ProductKit').open()
        }
    }

    /**
     * Close popup
     * @param {Event} e
     */
    _closePopup (e) {
        e.target.closest('[data-product-kit-popup]').classList.toggle(cssClasses.active)
        overlay('namespace:ProductKit').close()
    }
}

export default ProductKit



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductKit.js